<serviceos-ng-carousel-slider [carouselData]="modalData.onboardingModalItems" [showNavigationArrows]="true"></serviceos-ng-carousel-slider>